/**
 * /admin/firm-financials — Admin "Firm financials" hub (placeholder).
 *
 * Scaffold card (Beta batch 2, B2-2, 2026-07-08): routed + admin-gated now so the
 * nav slot exists; firm-level financials content hooks in here later.
 */
import { Alert, Container, Stack, Title } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

import { BackToCompliance } from '../components/BackToCompliance';
import { AccessDeniedAlert } from '../components/RequireAccess';
import { useCurrentUser } from '../hooks/useAuth';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export function FirmFinancialsPage() {
  useDocumentTitle('Firm financials');
  const { user } = useCurrentUser();

  if (!user) return null;
  if (user.role !== 'admin') return <AccessDeniedAlert />;

  return (
    <Container size="xl">
      <Stack>
        <BackToCompliance to="/admin" label="Back to Admin" />
        <Title order={2}>Firm financials</Title>
        <Alert icon={<IconInfoCircle size={16} />} color="gray" variant="light">
          This section is a placeholder — firm-level financials will be hooked in here.
        </Alert>
      </Stack>
    </Container>
  );
}
